export const microfrontendConfig = {
  rootElementId: '#__CertificatesApp__',
  getRootElement: () =>
    document.querySelector(microfrontendConfig.rootElementId),
  isMicrofrontend: () => !microfrontendConfig.getRootElement(),
  getBasename: () => {
    const publicUrl = process.env.REACT_APP_PUBLIC_URL;
    const basename = publicUrl ? new URL(publicUrl).pathname : '/';
    return basename;
  },
};
